import React, { FC, useMemo } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import ProductDashAppData from '../../models/DashApp/ProductDashAppData';
import useUserPermissions from '../../hooks/useUserPermissions';
import UserPermission from '../../models/Account/UserPermission';
import dashAppHelper from '../../helpers/dashAppHelper';

const DashAppButton: FC<Props> = ({ productDashAppData, className, fullSize = false, disabled }) => {
  const permissions = useUserPermissions();
  const navigate = useNavigate();
  const intl = useIntl();
  const hasDashAppAccess = permissions?.some(
    (x) => x === UserPermission.AllDashAppsAccess || x === UserPermission.DashAppAccess,
  );

  const onCkickButtonHandler = () => {
    navigate(dashAppHelper.getBaseDashAppPageUrl(productDashAppData.companyId, productDashAppData.productId));
    console.log(productDashAppData);
  };

  const button = useMemo(
    () => (
      <Button
        className={className}
        size={fullSize ? 'lg' : 'sm'}
        variant="outline"
        onClick={onCkickButtonHandler}
        data-test-id="dashApp-btn"
        disabled={disabled || !hasDashAppAccess}
      >
        <FormattedMessage id="dashAppButton.title" />
      </Button>
    ),
    [className, fullSize, onCkickButtonHandler, disabled, permissions, intl.locale],
  );

  return disabled || !hasDashAppAccess ? (
    <OverlayTrigger
      overlay={
        <Tooltip className="size-caption">
          <FormattedMessage id="dashAppButton.getFullAccessHint" />
        </Tooltip>
      }
    >
      <div className="d-inline-block">{button}</div>
    </OverlayTrigger>
  ) : (
    button
  );
};

interface Props {
  productDashAppData: ProductDashAppData;
  className?: string;
  fullSize?: boolean;
  disabled?: boolean;
}

export default DashAppButton;
